export default __webpack_public_path__ + "static/media/report_12.30ba8897.png";